import React from 'react';
import { Button, Card, CardBody, CardImg, CardSubtitle, CardText, CardTitle } from 'reactstrap';

function Blog({ blog }) {
  const { title, image, topics, desc, link, author } = blog;
  return (
    <Card
      className="border-0"
      style={{
        minWidth: '500px',
        margin: '10px',
        backgroundColor: 'white',
        color: 'black',
        padding: '5px',
      }}
    >
      <CardImg top width="100%" style={{ height: '150px' }} src={image} alt="Card image cap" />
      <CardBody className="p-3">
        <CardTitle tag="h5">{title}</CardTitle>
        <CardTitle tag="h6">{author}</CardTitle>
        <CardSubtitle tag="h6" className="mb-2 text-muted">
          {topics}
        </CardSubtitle>
        <CardText>{desc.substring(0, 120)}...</CardText>
        <Button target="_" href={link}>
          Read more...
        </Button>
      </CardBody>
    </Card>
  );
}

export default Blog;
